import {
  TransformationProfile,
  TransformationProfileInit,
  ListResult,
  TransformationProfileFilter,
} from 'common/api/v1/types'
import { BrowserEdgeClient } from '../network'
import type { RequestOptions } from 'common/network/request-options'
import { singleSortQueryFromPaginatedRequestParams, TransformationProfilesRequestParams } from '../nm-types'

export class TransformationProfilesApi {
  constructor(private readonly edgeClient: BrowserEdgeClient) {}

  async listTransformationProfiles(
    params: TransformationProfilesRequestParams,
    options?: Pick<RequestOptions, 'signal'>,
  ): Promise<ListResult<TransformationProfile>> {
    const filter = {
      searchName: params.filter,
      type: params.type,
    } as TransformationProfileFilter

    const query = singleSortQueryFromPaginatedRequestParams<TransformationProfileFilter, string>({
      filter,
      paginatedRequestParams: params,
    })

    return this.edgeClient.listTransformationProfiles(query, options)
  }

  async getTransformationProfile(id: string): Promise<TransformationProfile> {
    return this.edgeClient.getTransformationProfile(id)
  }

  async createTransformationProfile(data: TransformationProfileInit): Promise<TransformationProfile> {
    return this.edgeClient.createTransformationProfile(data)
  }

  async updateTransformationProfile(id: string, data: TransformationProfileInit): Promise<TransformationProfile> {
    return this.edgeClient.setTransformationProfile(id, data)
  }

  async deleteTransformationProfile(id: string): Promise<{ id: string }> {
    const result = await this.edgeClient.deleteTransformationProfile(id)
    return { id: result.id }
  }
}
